export interface NewsItem {
  id: number;
  title: string;
  tag: string;
  date: string;
  reads: string;
  summary: string;
}

export const newsList: NewsItem[] = [
  {
    id: 1,
    title: "新一季综艺官宣阵容，老熟人回归引发期待",
    tag: "综艺动态",
    date: "2026-08-15",
    reads: "23.1万",
    summary: "人气综艺官宣新一季阵容，多位观众熟悉的老面孔确认回归，消息一出话题迅速冲上热榜。",
  },
  {
    id: 2,
    title: "热播剧收视破纪录，网友在线考古名场面",
    tag: "热剧追踪",
    date: "2026-08-13",
    reads: "18.7万",
    summary: "近日热播剧收视一路走高并刷新纪录，网友们开启考古模式，集体回顾剧中的经典名场面。",
  },
  {
    id: 3,
    title: "明星机场街拍刷屏，这套穿搭被全网求同款",
    tag: "时尚八卦",
    date: "2026-08-11",
    reads: "15.2万",
    summary: "一组明星机场街拍意外走红，简约又高级的穿搭被无数网友求链接，时尚博主纷纷出解析。",
  },
  {
    id: 4,
    title: "音乐节现场直击：万人合唱感动全场",
    tag: "演出现场",
    date: "2026-08-09",
    reads: "21.4万",
    summary: "本周末音乐节现场气氛火爆，当经典曲目响起时万人合唱，现场视频在各大平台刷屏。",
  },
  {
    id: 5,
    title: "纪录片讲述平凡人的一天，网友直呼泪目",
    tag: "社会热议",
    date: "2026-08-06",
    reads: "12.9万",
    summary: "一部记录普通人日常的纪录片悄然走红，真实又温暖的画面让无数观众产生共鸣。",
  },
  {
    id: 6,
    title: "电竞战队夺冠时刻回放，弹幕瞬间炸开",
    tag: "游戏热点",
    date: "2026-08-03",
    reads: "30.5万",
    summary: "在刚刚结束的决赛中，战队在落后局面下实现翻盘夺冠，夺冠瞬间弹幕与欢呼声齐飞。",
  },
];